import React from 'react';
import PropType from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import './ExcludeButton.scss';

export default function ExcludeButton({
  disableLimit,
  limitTo = () => {
    Logger.error('limitTo something went wrong, value from ng is not a function');
  },
}) {
  return (
    <ButtonWithIcon
      type="borderless"
      size="small"
      tabIndex="0"
      linkIconSize="s"
      sprite="Forbidden"
      layout="vertical"
      onClick={() => limitTo({ exclude: true })}
      disabled={disableLimit}
      className="result-toolbar-exclude-button e2e-exclude"
      aria-label="Exclude">
      Exclude
    </ButtonWithIcon>
  );
}

ExcludeButton.propType = {
  limitTo: PropType.func,
  disableLimit: PropType.bool,
};
